import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation, Navigate, useNavigate } from 'react-router-dom';
import SayingsPage from './pages/SayingsPage';
import CategoriesPage from './pages/CategoriesPage';
import LanguagesPage from './pages/LanguagesPage';
import PublicSayingsPage from './pages/PublicSayingsPage';
import LoginPage from './pages/LoginPage';
import SayingDetailPage from './pages/SayingDetailPage';
import AdminSayingDetailPage from './pages/AdminSayingDetailPage';
import AboutPage from './pages/AboutPage';
import { Button } from './components/ui/button';
import { LogIn } from 'lucide-react';

function RequireAdmin({ children }) {
  const isAdmin = localStorage.getItem('isAdmin') === 'true';
  if (!isAdmin) {
    return <Navigate to="/login" replace />;
  }
  return children;
}

function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();
  const isAdmin = localStorage.getItem('isAdmin') === 'true';

  const handleLogout = () => {
    localStorage.removeItem('isAdmin');
    navigate('/');
  };

  return (
    <nav className="flex gap-2 p-4 bg-card shadow-sm mb-6 items-center">
      <Button asChild variant={location.pathname === '/' ? 'default' : 'ghost'}>
        <Link to="/">Inicio</Link>
      </Button>
      <Button asChild variant={location.pathname === '/dichos' ? 'default' : 'ghost'}>
        <Link to="/">Dichos</Link>
      </Button>
      <Button asChild variant={location.pathname === '/about' ? 'default' : 'ghost'}>
        <Link to="/about">Acerca de</Link>
      </Button>
      {isAdmin ? (
        <>
          <Button asChild variant={location.pathname === '/sayings' ? 'default' : 'ghost'}>
            <Link to="/sayings">Admin Dichos</Link>
          </Button>
          <Button asChild variant={location.pathname === '/categories' ? 'default' : 'ghost'}>
            <Link to="/categories">Categorías</Link>
          </Button>
          <Button asChild variant={location.pathname === '/languages' ? 'default' : 'ghost'}>
            <Link to="/languages">Lenguages</Link>
          </Button>
          <Button variant="outline" className="ml-auto" onClick={handleLogout}>
            Logout
          </Button>
        </>
      ) : (
        <Button asChild variant="outline" className="ml-auto" title="Admin Login">
          <Link to="/login">
            <LogIn className="h-5 w-5" />
          </Link>
        </Button>
      )}
    </nav>
  );
}

function App() {
  return (
    <Router>
      <Navigation />
      <main>
        <Routes>
          <Route path="/" element={<PublicSayingsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/sayings/:sayingId" element={<SayingDetailPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/sayings" element={<RequireAdmin><SayingsPage /></RequireAdmin>} />
          <Route path="/admin/sayings/:sayingId" element={<RequireAdmin><AdminSayingDetailPage /></RequireAdmin>} />
          <Route path="/categories" element={<RequireAdmin><CategoriesPage /></RequireAdmin>} />
          <Route path="/languages" element={<RequireAdmin><LanguagesPage /></RequireAdmin>} />
        </Routes>
      </main>
    </Router>
  );
}

export default App;
